// Shared dayjs instance for this feature with the `relativeTime` plugin enabled
// (used by the silo status overview's "read 3 hours ago" style timestamps).
// `apps/web` has no global dayjs setup module to hook into (plan.md S0: this goal
// may only touch its own route/feature files), so the plugin is registered once
// here — every component in this feature imports dayjs from this module instead
// of the bare package so `.fromNow()` always works regardless of import order.
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

export default dayjs;
